export default {
    test: () => {alert('bob!')},
    test2: () => {alert('bab!')},
    
}